// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tfJo","actions":"styles_actions__2AYf6","error":"styles_error__6K55e","message":"styles_message__b-XXi"};